// eslint-disable-next-line import/prefer-default-export
export const WORD_DECLENSIONS = {
  document: ["документ", "документа", "документов"],
  type: ["тип", "типа", "типов"],
} as const;
